import React from 'react'
import { Link } from 'react-router-dom'

export default function Landing() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
                <img src="/favicon.png" alt="SalesHub" className="w-8 h-8" />
                SalesHub
              </h1>
            </div>
            <Link
              to="/login"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              ログイン
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl font-bold text-gray-800 mb-6">
            営業メール作成を
            <span className="text-blue-500">効率化</span>
          </h2>
          <p className="text-xl text-gray-500 mb-8 max-w-2xl mx-auto">
            テンプレート管理と動的変数システムで、個別対応メールを瞬時に作成。
            営業活動の生産性を劇的に向上させます。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/login"
              className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 shadow-lg"
            >
              無料で始める
            </Link>
            <a
              href="#features"
              className="bg-white hover:bg-gray-50 text-gray-800 px-8 py-4 rounded-lg font-semibold text-lg border border-gray-200 transition-colors duration-200"
            >
              機能を見る
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">
              SalesHubの主要機能
            </h3>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              営業メール作成に必要な機能を全て搭載。直感的な操作で誰でも簡単に使えます。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">📧</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                テンプレート管理
              </h4>
              <p className="text-gray-500">
                よく使うメールテンプレートを保存・管理。カテゴリ別の整理で目的のテンプレートを素早く見つけられます。
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">🔄</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                動的変数システム
              </h4>
              <p className="text-gray-500">
                {`{{会社名}}`}や{`{{担当者名}}`}など、自由に変数を定義。一つのテンプレートで様々な相手に対応できます。
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">👀</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                リアルタイムプレビュー
              </h4>
              <p className="text-gray-500">
                変数を入力すると同時にメール内容が更新。送信前の最終確認で誤字脱字を防げます。
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">📋</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                ワンクリックコピー
              </h4>
              <p className="text-gray-500">
                完成したメールをワンクリックでクリップボードにコピー。そのままメーラーに貼り付けて送信できます。
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">🔐</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                簡単認証
              </h4>
              <p className="text-gray-500">
                メールアドレスのみでログイン可能。パスワード不要で安全かつ簡単にアクセスできます。
              </p>
            </div>

            {/* Feature 6 */}
            <div className="bg-blue-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <span className="text-white text-2xl">⚡</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-3">
                高速レスポンス
              </h4>
              <p className="text-gray-500">
                クラウドベースの高速システム。どこからでもアクセス可能で、チーム全体の効率を向上させます。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">
              簡単3ステップで始められます
            </h3>
          </div>

          <div className="space-y-12">
            {/* Step 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-full md:w-1/2">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mb-4">
                  1
                </div>
                <h4 className="text-2xl font-semibold text-gray-800 mb-4">
                  メールアドレスでログイン
                </h4>
                <p className="text-gray-500 text-lg">
                  メールアドレスを入力するだけで簡単ログイン。パスワードは不要です。送信されるリンクをクリックしてアクセス開始。
                </p>
              </div>
              <div className="w-full md:w-1/2">
                <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                  <div className="text-center">
                    <div className="text-6xl mb-4">📧</div>
                    <p className="text-gray-500">メール認証でセキュア</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8">
              <div className="w-full md:w-1/2">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mb-4">
                  2
                </div>
                <h4 className="text-2xl font-semibold text-gray-800 mb-4">
                  テンプレートを作成
                </h4>
                <p className="text-gray-500 text-lg">
                  よく使うメール文面をテンプレートとして保存。{`{{会社名}}`}、{`{{担当者名}}`}などの変数を使って柔軟なテンプレートを作成できます。
                </p>
              </div>
              <div className="w-full md:w-1/2">
                <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                  <div className="text-center">
                    <div className="text-6xl mb-4">✍️</div>
                    <p className="text-gray-500">直感的なエディタ</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-full md:w-1/2">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mb-4">
                  3
                </div>
                <h4 className="text-2xl font-semibold text-gray-800 mb-4">
                  変数を入力してコピー
                </h4>
                <p className="text-gray-500 text-lg">
                  テンプレートを選択し、変数に値を入力。リアルタイムでプレビューが更新され、完成したメールをワンクリックでコピーできます。
                </p>
              </div>
              <div className="w-full md:w-1/2">
                <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                  <div className="text-center">
                    <div className="text-6xl mb-4">🚀</div>
                    <p className="text-gray-500">即座に利用可能</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-500 flex-1">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold text-white mb-6">
            今すぐ営業効率を向上させませんか？
          </h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            無料でSalesHubを試して、営業メール作成にかかる時間を劇的に短縮しましょう。
          </p>
          <Link
            to="/login"
            className="bg-white hover:bg-gray-100 text-blue-500 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 shadow-lg inline-block"
          >
            無料で始める →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Left Section - Product Info */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <img src="/favicon.png" alt="SalesHub" className="w-6 h-6" />
                <div>
                  <h3 className="text-lg font-bold text-gray-800">SalesHub</h3>
                  <p className="text-sm text-gray-500">営業効率化ツール</p>
                </div>
              </div>
              <div className="hidden md:block text-gray-300">•</div>
              <div className="text-sm text-gray-500">
                <p>Version 1.0.0</p>
                <p>Last updated: 2025/1/1</p>
              </div>
            </div>

            {/* Right Section - Developer Info */}
            <div className="flex flex-col md:items-end gap-2">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span>Developed by</span>
                <a 
                  href="https://lunascent.net" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-200"
                >
                  しゅん。
                </a>
              </div>
              <p className="text-sm text-gray-400">© 2024 All rights reserved</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}